import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_ALL_LOCATION } from "../../../api-setup/api-endpoints";

export const fetchLocationForProvider = async (cookiesData, providerId, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_filter: null,
      in_sort_number: 1,
      in_sort_order: "ASC",
      in_page_row_offset: 0,
    };

    const response = await POSTAPI(false, GET_ALL_LOCATION, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      const rawData = response.data.row_result;

      const transformedData = rawData.map((location) => ({
        id: location.location_mstr_key,
        text: location.name,
      }));

      return {
        success: true,
        locationData: rawData,
        transformedData: transformedData,
        count: transformedData.length,
      };
    } else {
      console.error("Failed to fetch location for provider:", response?.message || "Invalid response structure");
      return {
        success: false,
        locationData: [],
        transformedData: [],
        count: 0,
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching location for provider:", error);
    return {
      success: false,
      locationData: [],
      transformedData: [],
      count: 0,
      error: error.message,
    };
  }
};
